import { ItemId, Project, DuplicateProject } from '../../../types/items';
import { ItemList, ListParams } from '../../../types/main';
import { action, withoutPayload, withPayload } from '../../../utility/redux';

export const initProjectRequest = action(
  'INIT_PROJECT_REQUEST',
  withoutPayload,
);
export const initProjectSuccess = action(
  'INIT_PROJECT_SUCCESS',
  withPayload<Project>(),
);
export const initProjectFail = action(
  'INIT_PROJECT_FAIL',
  withoutPayload,
);

export const createProjectRequest = action(
  'CREATE_PROJECT_REQUEST',
  withPayload<Project>(),
);
export const createProjectSuccess = action(
  'CREATE_PROJECT_SUCCESS',
  withPayload<Project>(),
);
export const createProjectFail = action(
  'CREATE_PROJECT_FAIL',
  withoutPayload,
);

export const getProjectListRequest = action(
  'GET_PROJECT_LIST_REQUEST',
  withPayload<ListParams>(),
);
export const getProjectListSuccess = action(
  'GET_PROJECT_LIST_SUCCESS',
  withPayload<ItemList<Project>>(),
);
export const getProjectListFail = action(
  'GET_PROJECT_LIST_FAIL',
  withoutPayload,
);

export const setProjectListDirty = action(
  'SET_PROJECT_LIST_DIRTY',
  withPayload<boolean>(),
);

export const getProjectRequest = action(
  'GET_PROJECT_REQUEST',
  withPayload<ItemId>(),
);
export const getProjectSuccess = action(
  'GET_PROJECT_SUCCESS',
  withPayload<Project>(),
);
export const getProjectFail = action('GET_PROJECT_FAIL', withoutPayload);

export const resetCurrentProject = action(
  'RESET_CURRENT_PROJECT',
  withoutPayload,
);

export const saveProjectRequest = action(
  'SAVE_PROJECT_REQUEST',
  withPayload<Project>(),
);
export const saveProjectSuccess = action(
  'SAVE_PROJECT_SUCCESS',
  withPayload<Project>(),
);
export const saveProjectFail = action('SAVE_PROJECT_FAIL', withoutPayload);

export const deleteProjectRequest = action(
  'DELETE_PROJECT_REQUEST',
  withPayload<ItemId>(),
);
export const deleteProjectSuccess = action(
  'DELETE_PROJECT_SUCCESS',
  withoutPayload,
);
export const deleteProjectFail = action(
  'DELETE_PROJECT_FAIL',
  withoutPayload,
);

export const duplicateProjectRequest = action(
  'DUPLICATE_PROJECT_REQUEST',
  withPayload<DuplicateProject>(),
);
export const duplicateProjectSuccess = action(
  'DUPLICATE_PROJECT_SUCCESS',
  withPayload<Project>(),
);
export const duplicateProjectFail = action(
  'DUPLICATE_PROJECT_FAIL',
  withoutPayload,
);

export const clearProjectList = action(
  'CLEAR_PROJECT_LIST',
  withoutPayload,
);

export const getProjectRefreshRequest = action(
  'GET_PROJECT_REFRESH_REQUEST',
  withPayload<ItemId>(),
);
export const getProjectRefreshSuccess = action(
  'GET_PROJECT_REFRESH_SUCCESS',
  withPayload<Project>(),
);

export const setAllowChangeProjectStatus = action(
  'SET_ALLOW_CHANGE_PROJECT_STATUS',
  withPayload<boolean>(),
);
export const updateProjectStatusRequest = action(
  'UPDATE_PROJECT_STATUS_REQUEST',
  withPayload<number>(),
);
export const updateProjectStatusSuccess = action(
  'UPDATE_PROJECT_STATUS_SUCCESS',
  withPayload<Project>(),
);
export const updateProjectStatusFail = action(
  'UPDATE_PROJECT_STATUS_FAIL',
  withoutPayload,
);
